import React from 'react';
import { Box, createStyles, makeStyles, Theme, Typography } from '@material-ui/core';
import DashboardCommission from '€components/DashboardCommission';
import DashboardApplicationList from '../DashboardApplicationList';

const useTitleStyles = makeStyles((theme: Theme) =>
    createStyles({
        title: {
            [theme.breakpoints.down('xs')]: {
                fontSize: '1.56rem',
            },
            [theme.breakpoints.up('sm')]: {
                fontSize: '2.19rem',
            },
        },
        avatar: {
            backgroundColor: theme.palette.text.primary,
        },
    }),
);

const Dashboard = () => {
    const classes = useTitleStyles();

    return (
        <Box px={{ xs: 0, md: 8 }}>
            <Box mt={4} mb={['0.9375rem', '1.25rem']} ml={2}>
                <Typography className={classes.title} variant="h2">
                    Commission
                </Typography>
            </Box>
            <DashboardCommission />
            <Box mt={4} mb={['0.9375rem', '1.25rem']} ml={2}>
                <Typography className={classes.title} variant="h2">
                    Live Applications
                </Typography>
            </Box>
            <DashboardApplicationList />
        </Box>
    );
};

export default React.memo(Dashboard);
